import configCode from "$loaderConfigCode.raw";
import { EntryContext } from "@linkjs/core";

/**
 * Linkjs加载器配置
 * @author wenyibin 00267441
 */
const EnvironmentName = "__linkjs_environment";
const w = window;
w[EnvironmentName] = w[EnvironmentName] || {};
w[EnvironmentName].isEs5Mode = ES5_MODE;

const context: EntryContext = {
    id: LOADER_ID,
    version: VERSION,
    isDevMode: DEV_MODE,
    isProdBuild: PROD_BUILD,
    isTestMode: TEST_MODE,
    compileVersion: COMPILE_VERSION,
    starter: STARTER_CONTEXT,
    extra: {
        tailwindConfig: TAILWIND && 
            require(TAILWIND_CONFIG_PATH),
        tailwindStyle: TAILWIND && 
            TAILWIND_STYLE_PATH && 
            require(`!!raw-loader!${TAILWIND_STYLE_PATH}`),
    }
};

export default {
    configCode,
    context
};